var _style, _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgAppliedDecree70(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 68 66",
    style: {
      enableBackground: "new 0 0 68 66"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#DC4300;}\r\n\t.st1{fill:#FF4E00;}\r\n\t.st2{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_466898_00000136398416182312798250000013350144362168152963_",
    className: "st0",
    d: "M32,0l36,36v30l-2-2V38L31,2H1.9L0,0H32 z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_466899_00000006693247281203468400000009332467241585947814_",
    className: "st1",
    d: "M32,0l36,36v28L2,0H32z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M25,12.9L24.1,12l1.3-5.9l-3.6,3.6L21,8.9L26,3.8l0.9,0.9l-1.3,5.9l3.6-3.6l0.9,0.9L25,12.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M27.7,11.8c0.6-0.6,1.2-0.9,1.8-1c0.6-0.1,1.2,0.1,1.6,0.6c0.4,0.4,0.6,0.9,0.6,1.5l0.4-0.3l0.8,0.8l-3.7,3.7 c-0.5,0.5-1,0.7-1.6,0.7c-0.6,0-1.2-0.3-1.7-0.8c-0.3-0.3-0.5-0.6-0.6-1c-0.1-0.4-0.2-0.7-0.2-1.1l0.9-0.1c0,0.6,0.1,1,0.5,1.4 c0.3,0.3,0.6,0.4,0.9,0.4c0.3,0,0.6-0.1,0.9-0.4l0.3-0.3c-0.5,0-1-0.2-1.4-0.6c-0.4-0.4-0.6-1-0.6-1.6C26.7,13,27.1,12.4,27.7,11.8 z M28.5,12.7c-0.4,0.4-0.6,0.8-0.7,1.1c-0.1,0.4,0,0.7,0.3,1c0.3,0.3,0.7,0.4,1.2,0.3l1.7-1.7c0.1-0.4,0-0.8-0.3-1.2 c-0.3-0.3-0.6-0.4-1-0.3S28.9,12.3,28.5,12.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M34.2,15.4c0.6,0,1.1,0.1,1.5,0.6c0.8,0.8,0.8,1.7-0.2,2.6L33.1,21l-0.8-0.8l2.4-2.4c0.3-0.3,0.4-0.5,0.4-0.7 c0-0.2-0.1-0.4-0.3-0.7C34.4,16,34,15.9,33.5,16l-2.7,2.7L30,17.9l5.4-5.4l0.8,0.8L34.2,15.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M33.1,22.6c0.1-0.1,0.3-0.2,0.4-0.2c0.2,0,0.3,0.1,0.5,0.2s0.2,0.3,0.2,0.5s-0.1,0.3-0.2,0.4 c-0.1,0.1-0.3,0.2-0.4,0.2c-0.2,0-0.3-0.1-0.5-0.2S33,23.2,33,23.1C33,22.9,33,22.8,33.1,22.6z M34.9,22.7L34,21.9l3.8-3.8l0.8,0.8 L34.9,22.7z M38.7,17.1c0.1-0.1,0.3-0.2,0.4-0.2c0.2,0,0.3,0.1,0.5,0.2s0.2,0.3,0.2,0.5c0,0.2-0.1,0.3-0.2,0.4 c-0.1,0.1-0.3,0.2-0.4,0.2c-0.2,0-0.3-0.1-0.5-0.2s-0.2-0.3-0.2-0.5C38.5,17.4,38.6,17.2,38.7,17.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M45.6,24.9L45,24.3l-4.3,4.3l-0.8-0.8l0.3-0.4c-0.6,0.1-1.1-0.1-1.5-0.6c-0.4-0.4-0.6-1-0.5-1.6 c0.1-0.6,0.4-1.2,1-1.9c0.6-0.6,1.2-0.9,1.8-1c0.6-0.1,1.2,0.1,1.6,0.6c0.4,0.4,0.6,0.9,0.6,1.4l0.8-0.8l-0.9-0.9l0.6-0.6l0.9,0.9 l0.5-0.5l0.8,0.8l-0.5,0.5l0.6,0.6L45.6,24.9z M40.1,24.3c-0.4,0.4-0.6,0.8-0.7,1.1c-0.1,0.4,0,0.7,0.3,1c0.3,0.3,0.8,0.4,1.2,0.3 l1.6-1.6c0.1-0.5,0-0.9-0.3-1.2c-0.3-0.3-0.6-0.4-1-0.3C40.9,23.6,40.5,23.9,40.1,24.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M41.1,30.6c0.1-0.1,0.3-0.2,0.4-0.2c0.2,0,0.3,0.1,0.5,0.2s0.2,0.3,0.2,0.5s-0.1,0.3-0.2,0.4 c-0.1,0.1-0.3,0.2-0.4,0.2c-0.2,0-0.3-0.1-0.5-0.2s-0.2-0.3-0.2-0.5C40.9,30.9,41,30.8,41.1,30.6z M42.8,30.7L42,29.9l3.8-3.8 l0.8,0.8L42.8,30.7z M46.7,25.1c0.1-0.1,0.3-0.2,0.4-0.2c0.2,0,0.3,0.1,0.5,0.2s0.2,0.3,0.2,0.5c0,0.2-0.1,0.3-0.2,0.4 c-0.1,0.1-0.3,0.2-0.4,0.2c-0.2,0-0.3-0.1-0.5-0.2s-0.2-0.3-0.2-0.5C46.5,25.4,46.6,25.2,46.7,25.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M48.3,28.7l-0.4,0.5c0.6-0.1,1.1,0.1,1.6,0.6c0.8,0.8,0.7,1.6-0.1,2.5l-2.5,2.5L46,33.9l2.4-2.4 c0.2-0.2,0.4-0.5,0.4-0.7c0-0.2-0.1-0.4-0.3-0.7c-0.3-0.3-0.8-0.4-1.2-0.3l-2.7,2.7l-0.8-0.8l3.8-3.8L48.3,28.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M51.9,33.1c0.6,0,1.1,0.1,1.5,0.6c0.8,0.8,0.8,1.7-0.2,2.6l-2.5,2.5L50,37.9l2.4-2.4c0.3-0.3,0.4-0.5,0.4-0.7 c0-0.2-0.1-0.4-0.3-0.7c-0.3-0.3-0.7-0.4-1.2-0.3l-2.7,2.7l-0.8-0.8l5.4-5.4l0.8,0.8L51.9,33.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M61.4,40.1l-6.6,2.6l-0.9-0.9l6.4-2.4l-2.6-2.6l0.7-0.7l3.5,3.5L61.4,40.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M62.9,46.5c-0.7,0.7-1.4,1.1-2.1,1.2c-0.6,0.1-1.2-0.1-1.8-0.7c-0.5-0.5-0.8-1.1-0.7-1.8 c0.1-0.6,0.5-1.3,1.2-2l0.9-0.9c0.7-0.7,1.4-1.1,2.1-1.2c0.6-0.1,1.2,0.1,1.8,0.7c0.6,0.6,0.8,1.1,0.7,1.8c-0.1,0.6-0.5,1.3-1.2,2 L62.9,46.5z M63,44.7c0.5-0.5,0.8-0.9,0.9-1.2c0.1-0.4,0-0.7-0.3-1c-0.3-0.3-0.6-0.4-0.9-0.3c-0.3,0.1-0.7,0.3-1.2,0.8l-1.1,1.1 c-0.5,0.5-0.8,0.9-0.9,1.3s0,0.7,0.3,1c0.3,0.3,0.6,0.4,0.9,0.3s0.8-0.4,1.2-0.8L63,44.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgAppliedDecree70);
export default __webpack_public_path__ + "static/media/img_applied_decree70.faee736acd7bf1a14f7c889b11ebbbc3.svg";
export { ForwardRef as ReactComponent };